export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/cst/need/sign/query`,
          data
        });
      },      
      list(data){
        return http.json({
          url: `/cst/need/sign/list`,
          data
        });
      },
      /**
       * 获取认证详情
       * @param data
       * @return {*}
       */
      getInfo(data) {
          return http.json({
              url: `/cst/need/sign/get?id=${data.id}`
          })
      },

      /**
       * 删除房产认证
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/cst/need/sign/delete?id=${data[0].id}`,
              data
          })
      },
      saveInfo(data) {
          return http.json({
              data,
              url: '/cst/need/sign/save',
          })
      },

      getSignInfo(data) {
          return http.json({
              url: `/cst/sign/record/getSignInfo?needId=${data.id}`,
          })
      },
      getNeedSignInfo(data) {
        return http.json({
            url: `cst/need/sign/get?id=${data.id}`,
        })
      },
      delCon(data) {
        return http.json({
          url: `cst/sign/record/delCon?houseId=${data.houseId}&phone=${data.phone}`,
      })
      }



  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/customerSign.js